export const Ed25519 = 'Ed25519';
export const RSA = 'RSA';
export const secp256k1 = 'secp256k1';
//# sourceMappingURL=index.js.map